import React, { useState, useEffect } from 'react';
import styles from './personality-results.module.css';

export type PersonalityArchetype = {
  Description: string;
  Description1: string;
  Name: string;
  Persona: string;
}

export type PersonalityImage = {
  url: string;
  name?: string;
}

interface PersonalityResultsUiProps {
  personalityCode: string | undefined;
  archetype: PersonalityArchetype | null;
  image: PersonalityImage | null;
  loading: boolean;
  onContinue: () => void;
}

function PersonalityResultsUi(props: PersonalityResultsUiProps) {
  const {
    personalityCode,
    archetype,
    image,
    loading,
    onContinue,
  } = props;

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (loading) {
      // Reset progress when loading starts
      setProgress(0);

      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            return 100;
          }
          // Gradually increase progress over 2.5 seconds
          return prev + (100 / 25); // 100% over 25 intervals (100ms each = 2.5s)
        });
      }, 100);

      return () => clearInterval(interval);
    }
  }, [loading]);

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.progressContainer}>
          <div className={styles.progressBar}>
            <div
              className={styles.progressFill}
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className={styles.progressText}>{Math.round(progress)}%</div>
        </div>
        <div className={styles.loadingText}>Analyzing your results</div>
        <div className={styles.loadingText}>Creating your unique personality profile</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>{`You are ${archetype?.Name}!`}</div>

        {image && (
          <img
            src={image.url}
            alt={personalityCode}
            className={styles.image}
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
        )}

        <div className={styles.description}>
          Like <span className={styles.name}>{archetype?.Persona}</span>, {archetype?.Description}
        </div>
        <div className={styles.description}>{archetype?.Description1}</div>
      </div>

      <button onClick={onContinue} className={styles.button}>
        Continue
      </button>
    </div>
  );
}

export default PersonalityResultsUi;
